import { CheckMark } from '@/core/components/CheckMark';

import {
  CheckMarkWrapper,
  DonateLink,
  DonateLinkWrapper,
  ShareIconsWrapper,
  ThankYouHeadline,
  WantMoreText,
  Wrapper,
} from './ThankYouWrapper.styles';
import { ShareIcons } from '../ShareIcons';

interface ThankYouWrapperProps {
  borderColor: string;
  buttonColor: string;
  children: React.ReactNode;
  isDonateButton: boolean;
  isFullScreen?: boolean;
  linkDonate: string | null;
  name: string;
  socialShareButtonEnabled: boolean;
  textcolor: string;
  uuid?: string | Array<string>;
}

export const ThankYouWrapper = ({
  borderColor,
  buttonColor,
  children,
  isDonateButton,
  isFullScreen,
  linkDonate,
  name,
  socialShareButtonEnabled,
  textcolor,
  uuid,
}: ThankYouWrapperProps) => (
  <Wrapper
    $borderColor={borderColor}
    $isFullScreen={isFullScreen}
  >
    <CheckMarkWrapper>
      <CheckMark backgroundColor={textcolor} />
    </CheckMarkWrapper>
    <ThankYouHeadline>{name}</ThankYouHeadline>
    {children}
    {isDonateButton && linkDonate && (
      <DonateLinkWrapper>
        <DonateLink
          backgroundcolor={buttonColor}
          href={linkDonate.startsWith('http://') || linkDonate.startsWith('https://') ? linkDonate : `https://${linkDonate}`}
          rel="noreferrer"
          textcolor={textcolor}
          target="_blank"
        >
          Donate
        </DonateLink>
      </DonateLinkWrapper>
    )}
    {socialShareButtonEnabled && typeof uuid === 'string' && (
      <>
        <WantMoreText>Take one more step and share with your friends</WantMoreText>
        <ShareIconsWrapper>
          <ShareIcons
            textcolor={buttonColor}
            customIcons
            uuid={uuid}
          />
        </ShareIconsWrapper>
      </>
    )}
  </Wrapper>
);

ThankYouWrapper.defaultProps = {
  uuid: null,
};
